export default async function urlToFile(
  url: string,
  filename: string
): Promise<File> {
  const response = await fetch(url);
  const blob = await response.blob();

  return new File([blob], filename);
}
